const LOCALSTORAGE_KEY = 'imea.portal'

function persistToken(data) {
  window.localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(data))
}

function getToken() {
  const userString = window.localStorage.getItem(LOCALSTORAGE_KEY)
  let token = null
  if (userString) {
    token = JSON.parse(userString).access_token
  }
  return token
}

function getUserData() {
  const userString = window.localStorage.getItem(LOCALSTORAGE_KEY)
  let data = null
  if (userString) {
    data = JSON.parse(userString)
  }
  return data
}

export { persistToken, getToken, getUserData }
